import React from 'react';
import { Loader2, ChevronDown } from 'lucide-react';
import Button from '../../../components/ui/Button';

const LoadMoreButton = ({ 
  onLoadMore, 
  loading = false, 
  hasMore = false, 
  currentCount = 0, 
  totalCount = 0 
}) => {
  
  if (!hasMore) {
    return (
      <div className="text-center py-8">
        <p className="text-muted-foreground">
          You've viewed all {totalCount} available events
        </p>
      </div>
    );
  }

  return (
    <div className="text-center py-8">
      {/* Progress Indicator */}
      <div className="mb-4">
        <div className="text-sm text-muted-foreground mb-2">
          Showing {currentCount} of {totalCount} events
        </div>
        <div className="w-full max-w-sm mx-auto bg-secondary rounded-full h-2">
          <div 
            className="bg-primary h-2 rounded-full transition-all duration-300"
            style={{ 
              width: totalCount > 0 ? `${(currentCount / totalCount) * 100}%` : '0%' 
            }}
          />
        </div>
      </div>

      {/* Load More Button */}
      <button
        onClick={onLoadMore}
        disabled={loading}
        className="flex items-center justify-center gap-2 px-8 py-3 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-semibold"
      >
        {loading ? (
          <>
            <Loader2 className="w-5 h-5 animate-spin" />
            Loading more events...
          </>
        ) : (
          <>
            <ChevronDown className="w-5 h-5" />
            Load More Events ({totalCount - currentCount} remaining)
          </>
        )}
      </button>

      {/* Additional Info */}
      <p className="text-xs text-muted-foreground mt-3">
        Loading {Math.min(12, totalCount - currentCount)} more events
      </p>
    </div>
  );
};

export default LoadMoreButton;